import React from 'react';

interface IIconProps {
  width?: number;
  height?: number;
  className?: string;
}

const SearchIcon = (props: IIconProps) => {
  const { width = 24, height = 24, className } = props;

  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fillRule="evenodd">
        <path fillOpacity=".01" fill="#FFF" d="M0 0h24v24H0z" />
        <g transform="translate(3 3)" stroke="#111" strokeWidth="2">
          <circle cx="7.2" cy="7.2" r="7.2" />
          <path strokeLinecap="square" d="M12 12.6l5.091 5.091" />
        </g>
      </g>
    </svg>
  );
};

export default React.memo(SearchIcon);
